import { useDynamicEntity } from './useDynamicEntity';
import { useAuth } from './index';
import { formatDateForHasura } from '../utils/dateUtils';

export const useExpenses = (showAllExpenses = false, userId = null, { paginated = false } = {}) => {
  const { user } = useAuth();
  
  const targetUserId = userId || user?.id;

  const dynamicHook = useDynamicEntity({
    entityType: 'expenses',
    gqlEntityKey: 'expense_requests',
    queryName: 'GET_EXPENSES_QUERY',
    createMutation: 'CREATE_EXPENSE_MUTATION',
    updateMutation: 'UPDATE_EXPENSE_MUTATION',
    deleteMutation: 'DELETE_EXPENSE_MUTATION',
    serverPagination: paginated,
    aggregateKey: paginated ? 'expense_requests_aggregate' : null,
    customWhereCondition: showAllExpenses
      ? (user?.role === 'ROOT' ? {} : { company_id: { _eq: user?.companyId } })
      : { user_id: { _eq: targetUserId } },
    transformData: expense => {
      return {
        id: expense.id,
        expenseDate: expense.expense_date,
        expenseTypeName: expense.expense_type?.expense_type_name || '',
        amount: expense.amount,
        description: expense.description,
        status: expense.status,
        rejectReason: expense.reject_reason,
        approvingManagerId: expense.approving_manager_id,
        approvingDate: expense.approving_date,
        paidAmount: expense.paid_amount,
        user: expense.user,
        approvingManager: expense.approving_manager,
        team: expense.user?.team,
        teamName: expense.user?.team?.name || '',
        team_name: expense.user?.team?.name || '',
        group: expense.user?.team?.group,
        groupName: expense.user?.team?.group?.name || '',
        group_name: expense.user?.team?.group?.name || '',
        companyName: expense.user?.company?.name || '',
        company_name: expense.user?.company?.name || '',
      };
    },
    transformFormData: formData => {
      // expense_date column is `timestamp`; send a timezone-free local timestamp
      // so Istanbul-selected dates don't shift after UTC round-trip (Bug 1).
      const expenseDateLocal = formatDateForHasura(formData.expenseDate);
      const transformedData = {
        expense_date: expenseDateLocal ? `${expenseDateLocal}T00:00:00` : null,
        expense_type_id: formData.expenseType,
        amount: formData.amount,
        description: formData.description,
        company_id: formData.userId ? formData.selectedUserCompanyId : user?.companyId,
        user_id: formData.userId || targetUserId,
        status: 'PENDING',
      };

      return transformedData;
    },
  });

  return {
    ...dynamicHook,
    expenses: dynamicHook.expenses,
  };
};

